import { ITEMS_PER_PAGE } from '@mais-retorno-front/constants/items-per-page';
import { getVideoThumbFromYoutube } from '@mais-retorno-front/helpers/video-thumb';
import { IContent } from '@mais-retorno-front/models/content';
import { AxiosInstance } from 'axios';

interface IVideosList {
  videos: IContent[];
  totalPages: number;
}

interface IResponse {
  data: {
    videos: {
      data: {
        id: string;
        attributes: {
          title: string;
          publishedAt: string;
          excerpt: string;
          path: string;
          video_id: string;
          slug: string;
        };
      }[];
      meta: {
        pagination: {
          pageCount: number;
        };
      };
    };
  };
}

export class GetContentToVideosListUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(page = 1): Promise<IVideosList> {
    const { data } = await this.http.post<IResponse>('', {
      query: `
        query videos {
          videos(pagination: { page: ${page}, pageSize: ${ITEMS_PER_PAGE.videos} }, sort: "publishedAt:desc") {
            data {
              id
              attributes {
                title
                publishedAt
                excerpt
                path
                video_id
                slug
              }
            }
            meta {
              pagination {
                pageCount
              }
            }
          }
        }
      `,
    });

    if (!data?.data?.videos?.data) {
      return {
        videos: null,
        totalPages: null,
      };
    }

    const videos: IContent[] = data?.data?.videos?.data?.map(
      ({ attributes, id }) => {
        return {
          contentId: +id,
          title: attributes?.title || null,
          slug: attributes?.slug || null,
          excerpt: attributes?.excerpt || null,
          date: attributes?.publishedAt || null,
          imageUrl:
            getVideoThumbFromYoutube(attributes?.video_id) ||
            '/img/placeholder.png',
          imageTitle: attributes?.title,
          imageAltText: attributes?.title,
          link: `${attributes?.path}/${attributes?.slug}` || null,
          type: 'video',
        };
      }
    );

    return {
      videos,
      totalPages: data?.data?.videos?.meta?.pagination?.pageCount,
    };
  }
}
